export const MAXIMUM_POPULAR_FACILITIES = 6
